<template>
  <div>
    <hr class="mt-2 mb-2 dotted-line tm15" />
    <div class="d-flex bm15">
      <slot class=""></slot>
      <span class="mr-auto section-title">{{text}}<span class="section-value">{{value}}</span></span>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    text: String,
    value: String
  }
}
</script>

<style>
.tm15 {
  margin-top: 1.5em !important;
}
.bm15 {
  margin-bottom: 1.5em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DottedLineHeader.vue